import type { AuthResponse, MeResponse } from '@nargus/shared';
import { download, request, upload } from '../http';

export interface RegisterInput {
  email: string;
  password: string;
  name?: string;
}

export interface LoginInput {
  email: string;
  password: string;
}

export const authResource = {
  register: (input: RegisterInput): Promise<AuthResponse> =>
    request('/auth/register', { method: 'POST', body: JSON.stringify(input) }),

  login: (input: LoginInput): Promise<AuthResponse> =>
    request('/auth/login', { method: 'POST', body: JSON.stringify(input) }),

  me: (): Promise<MeResponse> => request('/auth/me'),

  setAvatar: (file: File): Promise<MeResponse> => {
    const body = new FormData();
    body.append('avatar', file);
    return upload('/users/me/avatar', body, 'PUT');
  },

  removeAvatar: (): Promise<MeResponse> =>
    request('/users/me/avatar', { method: 'DELETE' }),

  avatar: (userId: string): Promise<Blob> => download(`/users/${userId}/avatar`),
};
